import { RootState } from 'store/root.reducer'

const root = (state: RootState) => state.theme
export const getTheme = (state: RootState) => root(state)

export const getLogo = (state: RootState) => root(state).logo
export const getColorsPalette = (state: RootState) => root(state).colors
export const getGovSystemsConfig = (state: RootState) => root(state).govSystemsConfig
